import * as moment from 'moment';
import { ICellRendererParams } from 'ag-grid-community';
import { IMicrositeCampaignListing } from '@nkr/models/microsites/index';
import { CampaignType } from '@nkr/enums/index';
import { CampaignAction } from './campaign-action';
import OverlayMenuButton from '@nkr/components/overlay-menu-button';
import { connect, Dispatch } from 'react-redux';
import { IApplicationState, IAppState, MicrositeActionCreators } from '@nkr/store/index';
import { downloadFile } from '@nkr/services/download-file';

const menuItemList = [
    { action: CampaignAction.Edit, title: 'Edit' },
    { action: CampaignAction.Delete, title: 'Delete' },
    { action: CampaignAction.DownloadMailingList, title: 'Download Mailing List' },
    { action: CampaignAction.UploadMailingList, title: 'Upload Mailing List' },
    { action: CampaignAction.EditColumnMapping, title: 'Edit Column Mapping' },
    
    { action: CampaignAction.ConfirmMailingList, title: 'Confirm Mailing List' },
    { action: CampaignAction.UploadSignatureFile, title: 'Upload Signature File' },
    { action: CampaignAction.ViewSignatureFile, title: 'View Signature File' },
    { action: CampaignAction.EditLetter, title: 'Edit Letter' },
    { action: CampaignAction.MergeListLetter, title: 'Merge List & Letter (PDF)' },
    { action: CampaignAction.OrderBrochures, title: 'Order Brochures' },
    { action: CampaignAction.DownloadBrochurePdf, title: 'Download Brochure PDF' },
    { action: CampaignAction.DownloadMailingFiles, title: 'Download Mailing Files' },
    { action: -1, title: '' }
];

interface IProps extends ICellRendererParams {
    data: IMicrositeCampaignListing,
    isAdmin: boolean,
    onMenuToggle: (show: boolean) => void,
    onMenuSelection: (eventKey: number, campaignId: number) => void
}
interface IStateProps {
    app: IAppState
}

interface IDispatchProps {
    downloadMailingList: (campaignId: number) => Promise<any>
}

type TProps = IProps & IStateProps & IDispatchProps;

const ActionButtonRenderer = (props: TProps) => {
    
    const isSuperAdmin = props.app.user.group.isSuper;
    
    const handleMenuToggle = (show: boolean) => {
        props.onMenuToggle(show);
    };

    const handleMenuSelection = (e: any) => {
        
        if (e == CampaignAction.DownloadMailingList) {
            props.downloadMailingList(props.data.id).then((response: any) => {
                downloadFile(response.data, `campaign-${props.data.id}-mailing-list.csv.csv`, 'text/csv');
            });
        }

        props.onMenuSelection(parseInt(e), props.data.id);
    };

    const getUrl = (eventKey: CampaignAction) => {
        let baseUrl = props.isAdmin ? '/admin/microsite/campaign' : '/center/' + props.data.centerId + '/microsite/campaign';

        switch (eventKey) {
            case CampaignAction.Edit: return { url: `${baseUrl}/${props.data.id}`, isNewTab: false };
            case CampaignAction.UploadMailingList: return { url: `${baseUrl}/${props.data.id}/mailing-list`, isNewTab: false };
            case CampaignAction.EditColumnMapping: return { url: `${baseUrl}/${props.data.id}/mailing-list-mapping`, isNewTab: false };
            case CampaignAction.ConfirmMailingList: return { url: `${baseUrl}/${props.data.id}/confirm-mailing-list`, isNewTab: false };
            case CampaignAction.UploadSignatureFile: return { url: `${baseUrl}/${props.data.id}/upload-signature-file`, isNewTab: false };
            case CampaignAction.ViewSignatureFile: return { url: `${baseUrl}/${props.data.id}/upload-signature-file`, isNewTab: false };
            case CampaignAction.EditLetter: return { url: `${baseUrl}/${props.data.id}/edit-letter`, isNewTab: false };
            case CampaignAction.DownloadBrochurePdf: return { url: '/pdf/microsites_ALT_brochure_trifold_v1.pdf', isNewTab: true };
            case CampaignAction.MergeListLetter: return { url: __API__ + '/microsite/campaign/' + props.data.id + '/mail-merge', isNewTab: true };
            case CampaignAction.DownloadMailingFiles: return { url: `${baseUrl}/${props.data.id}/mailing-package`, isNewTab: false };
            case CampaignAction.DownloadMailingList: return null;
        }
    };

    const getMenuItems = () => {
        let isActive = moment(props.data.startDate).isBefore(moment()) && moment(props.data.endDate).isAfter(moment());
        let isMailedOut = props.data.campaignTypeId == CampaignType.MailedOut;
        let canDelete = isActive == false && props.data.useCount == 0;
        let menuItems: CampaignAction[] = [];

        menuItems.push(CampaignAction.Edit);

        if (canDelete) {
            menuItems.push(CampaignAction.Delete)
        }

        if (isMailedOut) {

            
            menuItems.push(CampaignAction.UploadMailingList);

            if (props.data.mailingListFileName != '') {
                menuItems.push(CampaignAction.EditColumnMapping);

                if (props.data.mailingListColumnMapping.length > 0 && props.data.mailingListColumnMapping[0]) {
                    if (!props.data.mailingListValidated) {
                        menuItems.push(CampaignAction.ConfirmMailingList);
                    }
                }

                if (props.data.mailingListValidated) {
                    
                    if (isSuperAdmin) {
                        menuItems.push(CampaignAction.DownloadMailingList);
                    }
                    
                    menuItems.push(CampaignAction.Divider);

                    if (props.data.campaignSignatureFileName != '') {
                        menuItems.push(CampaignAction.ViewSignatureFile);
                    } else {
                        menuItems.push(CampaignAction.UploadSignatureFile);
                    }

                    menuItems.push(CampaignAction.Divider);
                    
                    if (isSuperAdmin) {
                        menuItems.push(CampaignAction.EditLetter);
                    }

                    if (props.data.mailingListValidated && props.data.letterContentsDateTime != '' && isSuperAdmin) {
                        menuItems.push(CampaignAction.MergeListLetter);
                    }

                    menuItems.push(CampaignAction.OrderBrochures);
                    menuItems.push(CampaignAction.DownloadBrochurePdf);

                    if (props.data.mailingListValidated && props.data.letterContentsDateTime != '' && isSuperAdmin) {
                        menuItems.push(CampaignAction.DownloadMailingFiles);
                    }
                }
            }
        }

        return menuItems;
    };

    const dataLength = props.api.getModel().getRowCount();
    // const dropup = dataLength <= 18 ? false : props.rowIndex + 1 > dataLength - 6;

    const menuItems = getMenuItems().map(item => {
        return menuItemList.find(x => x.action == item);
    });

    const menu = menuItems.map(item => {
        let actionUrl = item.action != -1 ? getUrl(item.action) : null;
        let id = item.action >= 0 ? props.data.id : 'div-' + props.data.id + '-' + Math.random() * 10000;

        if (actionUrl == null) {
            if (item.action >= 0) {
                return { id, action: item.action, include: true, selectable: true, element: <>{item.title}</> };
            } else {
                return { id, action: item.action, include: true, selectable: false, element: <div style={{ height: 10 }}></div>, divider: true };
            }
        } else {
            return { id, action: item.action, include: true, selectable: false, element: <a href={actionUrl.url} target={actionUrl.isNewTab ? '_blank' : null}>{item.title}</a> };
        }
    });

    return (
        <OverlayMenuButton
            menu={menu}
            bsStyle='primary'
            bsSize='xs'
            title='Actions'
            listItemStyle={{ padding: '2px 7.5px', minWidth: 100, fontSize: 14 }}
            includeCaret={true}
            onToggle={handleMenuToggle}
            onSelect={(id, action) => handleMenuSelection(action)}
        />
    );
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => {
    return {
        downloadMailingList: (campaignId) => {
            return dispatch(MicrositeActionCreators.downloadMailingList(campaignId));
        },
    };
}
export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(ActionButtonRenderer);
